module.exports = __webpack_public_path__ + "img/app_icon_63.6014fd5a.png";